module.exports = __webpack_public_path__ + "img/logo-volksbank.925cc387.svg";